import type { StyleRule } from '@archipro-design/aria';

export const GuestHomeContainer: StyleRule = () => ({
    background: '#F3F3F3',
});
